const e = {
  inert: ":not([inert]):not([inert] *)",
  negTabIndex: ':not([tabindex^="-"])',
  disabled: ":not(:disabled)"
}, n = [
  `a[href]${e.inert}${e.negTabIndex}`,
  `area[href]${e.inert}${e.negTabIndex}`,
  `input:not([type="hidden"]):not([type="radio"])${e.inert}${e.negTabIndex}${e.disabled}`,
  `input[type="radio"]${e.inert}${e.negTabIndex}${e.disabled}`,
  `select${e.inert}${e.negTabIndex}${e.disabled}`,
  `textarea${e.inert}${e.negTabIndex}${e.disabled}`,
  `button${e.inert}${e.negTabIndex}${e.disabled}`,
  `details${e.inert} > summary:first-of-type${e.negTabIndex}`,
  // Discard until Firefox supports `:has()`
  // See: https://github.com/KittyGiraudel/focusable-selectors/issues/12
  // `details:not(:has(> summary))${not.inert}${not.negTabIndex}`,
  `iframe${e.inert}${e.negTabIndex}`,
  `audio[controls]${e.inert}${e.negTabIndex}`,
  `video[controls]${e.inert}${e.negTabIndex}`,
  `[contenteditable]${e.inert}${e.negTabIndex}`,
  `[tabindex]${e.inert}${e.negTabIndex}`
];
export {
  n as default
};
